import styled from 'styled-components';

const MoneyContainer = styled.div`
	margin: 2px 0px 10px 0px;
	min-height: 120px;

	p {
		color: #515151;
	}
	${props => props.theme.breakpoints.up('xs')} {
		.money__last-value {
			font-weight: 600;
			font-size: 15px;
			min-height: 0px;
			color: #cc0000;
		}

		.money__promotion {
			font-weight: 400;
			font-size: 15px;
			min-height: 0px;
			margin-bottom: 12px;
		}

		.money__value {
			font-weight: 400;
			font-size: 44px;
			padding: 10px;
			line-height: 16px;
		}

		.money__value__big {
			font-size: 55px;
		}

		.money__description {
			font-weight: 700;
			font-size: 9px;
			min-height: 0px;
		}
	}

	${props => props.theme.breakpoints.up('sm')} {
		.money__last-value {
			font-size: 20px;
			color: #cc0000;
			min-height: 24px;
		}

		.money__promotion {
			font-weight: 400;
			font-size: 20px;
			min-height: 0px;
			margin-bottom: 12px;
		}

		.money__value {
			font-size: 45px;
			padding: 5px;
			line-height: 24px;
		}

		.money__value__big {
			font-size: 55px;
		}
		.money__description {
			font-size: 12px;
			min-height: 24px;
		}
	}

	.line {
		width: 53px;
		height: 31px;
		left: 42%;
		border-bottom: 1px solid red;
		transform: translateY(-20px) translateX(5px) rotate(16deg);
		position: absolute;
	}
`;

export default MoneyContainer;
